/*
 * @format
 */

import uuid from 'uuid/v4';
import * as actionTypes from '../action-types';

// [
//   {
//     requestId: asd876a-aksjdbakj-a271wdbjkas,
//     homeId: '25062019000000',
//     title: 'prt-123 has lost connection',
//     type: 'deviceOffline',
//     body: 'Check the System Status page for tips on how to get your device back online',
//     raised: 1571223842127
//   }
// ]

const initialState = { notifications: [] };

export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.LOGOUT_COMPLETED:
      return initialState;

    case actionTypes.NOTIFICATION_TOKEN_UPDATED:
      return {
        ...state,
        deviceToken: action.deviceToken,
      };

    case actionTypes.NOTIFICATION_RECEIVED:
      return {
        ...state,
        notifications: [
          ...state.notifications,
          {
            requestId: uuid(),
            homeId: action.data.homeId,
            title: action.data.title,
            body: action.data.body,
            type: action.data.type,
            raised: Date.now(),
          },
        ],
      };

    case actionTypes.DISMISS_ERROR:
      return {
        ...state,
        notifications: [
          ...state.notifications.filter(x => x.requestId !== action.requestId),
        ],
      };
    default:
      return state;
  }
};
